import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
import { Checkbox } from '@instructure/ui-checkbox';
import { omitProps } from '@instructure/ui-react-utils';
import { TextInput } from '@instructure/quiz-common';
var maskedTextInputPropTypes = {
  /**
   * The label to be used for the checkbox that controls whether the input is masked
   */
  checkboxLabel: PropTypes.string.isRequired,
  /**
   * Whether or not the input text is masked
   */
  masked: PropTypes.bool,
  /**
   * The function to call when the user clicks the checkbox to either mask or unmask the input
   */
  onMaskedChange: PropTypes.func
};
export var MaskedTextInput = /*#__PURE__*/function (_Component) {
  function MaskedTextInput() {
    _classCallCheck(this, MaskedTextInput);
    return _callSuper(this, MaskedTextInput, arguments);
  }
  _inherits(MaskedTextInput, _Component);
  return _createClass(MaskedTextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        checkboxLabel = _this$props.checkboxLabel,
        masked = _this$props.masked,
        onMaskedChange = _this$props.onMaskedChange,
        type = _this$props.type;
      var textInputProps = _objectSpread(_objectSpread({}, omitProps(this.props, maskedTextInputPropTypes)), {}, {
        type: masked ? 'password' : type
      });
      return /*#__PURE__*/React.createElement(View, {
        as: "div"
      }, /*#__PURE__*/React.createElement(TextInput, textInputProps), /*#__PURE__*/React.createElement(View, {
        as: "div",
        margin: "small 0"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: checkboxLabel,
        checked: !masked,
        onChange: onMaskedChange
      })));
    }
  }]);
}(Component);
_defineProperty(MaskedTextInput, "propTypes", _objectSpread(_objectSpread({}, maskedTextInputPropTypes), TextInput.propTypes));
_defineProperty(MaskedTextInput, "defaultProps", _objectSpread(_objectSpread({}, TextInput.defaultProps), {}, {
  masked: true,
  onMaskedChange: Function.prototype
}));
export default MaskedTextInput;